module.exports = __webpack_public_path__ + "static/media/detroveLogo.314aeadb.svg";